var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 0.5C4.39543 0.5 3.5 1.39543 3.5 2.5V10.5C3.5 11.6046 4.39543 12.5 5.5 12.5H13.5C14.6046 12.5 15.5 11.6046 15.5 10.5V2.5C15.5 1.39543 14.6046 0.5 13.5 0.5H5.5ZM13.5 2H5.5C5.22386 2 5 2.22386 5 2.5V10.5C5 10.7761 5.22386 11 5.5 11H13.5C13.7761 11 14 10.7761 14 10.5V2.5C14 2.22386 13.7761 2 13.5 2Z",
    fill: "#4C545B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00246 3.8999C2.00083 3.93305 2 3.96642 2 3.99998V12C2 13.1045 2.89543 14 4 14H12C12.0336 14 12.0669 13.9992 12.1001 13.9975C11.5817 14.8956 10.6114 15.5 9.5 15.5H3.5C1.84315 15.5 0.5 14.1568 0.5 12.5V6.49998C0.5 5.38854 1.1044 4.41827 2.00246 3.8999Z",
    fill: "#4C545B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.a537355bb2bc4bb9da800888b7e2b1a1.svg";
export { ForwardRef as ReactComponent };